import styled from '@emotion/styled';
import { Button } from 'src/domains/layouts/webview/components/common/button/Button';

export const PayButton = styled(Button, { label: 'PayButton' })`
    margin-top: 32px;
    text-transform: capitalize;
    width: 100%;
`;
